import { RichText } from '@graphcms/rich-text-react-renderer';
import { SectionTitle } from '@/sem/styles';
import { useIsMobile } from '~/context/common/DeviceContext';
import type { SemWhyCarvanaModule } from '~/contracts/sem';
import { SemBrandMarketingContentItem } from '~/contracts/sem/SemLandingPageContent';
import { ImageWrapper, InnerWrapper } from './WhyCarvana.styles';
import SemTrackWrapper from '../SemTrackWrapper';

function WhyCarvana({ title, items, image }: SemWhyCarvanaModule) {
  const isMobile = useIsMobile();
  const imageSrc = (isMobile ? image?.mobile : image?.desktop) ?? '';

  return (
    <SemTrackWrapper sectionName="Why Carvana">
      <InnerWrapper>
        <ImageWrapper>
          <picture>
            <source srcSet={imageSrc} media="(min-width: 1440px)" />
            <img className="h-full w-full" src={imageSrc} alt="Why Carvana" />
          </picture>
        </ImageWrapper>
        <div className="flex flex-col">
          <SectionTitle className="l:tl-header-xxl">{title}</SectionTitle>
          {items.map(
            ({ bodyRichText, id }: SemBrandMarketingContentItem) =>
              bodyRichText && (
                <RichText
                  key={id}
                  content={bodyRichText}
                  renderers={{
                    a: ({ children, openInNewTab, href, rel, ...rest }) => (
                      <a
                        href={href}
                        target={openInNewTab ? '_blank' : '_self'}
                        rel={`noreferrer ${rel}`}
                        data-analytics-id="Why Carvana - Rich Text Link"
                        data-analytics-attributes={JSON.stringify({
                          linkUrl: href
                        })}
                        {...rest}
                      >
                        {children}
                      </a>
                    ),
                    h3: ({ children }) => (
                      <h3 className="mb-8 mt-24 text-blue-6 tl-header-m">
                        {children}
                      </h3>
                    ),
                    p: ({ children }) => (
                      <p className="text-grey-5 tl-body-m">{children}</p>
                    ),
                    bold: ({ children }) => (
                      <b className="font-bold">{children}</b>
                    )
                  }}
                />
              )
          )}
        </div>
      </InnerWrapper>
    </SemTrackWrapper>
  );
}

export default WhyCarvana;
